/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  WithPrice,
  WithPriceOptional,
  WithPriceMetaI,
  WithPriceTrackedI,
} from "./with-price";
import { WithPriceTracked, WithPriceMeta } from "./with-price";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSignupMax,
  WithSignupMaxOptional,
  WithSignupMaxMetaI,
  WithSignupMaxTrackedI,
} from "./with-signup-max";
import { WithSignupMaxTracked, WithSignupMaxMeta } from "./with-signup-max";

/**
 *
 * @export
 * @interface UnifiedClassInstanceBase
 */
export interface UnifiedClassInstanceBaseOptional extends WithPriceOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceBase
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceBase
   */
  signupMax?: number;
}

export interface UnifiedClassInstanceBase
  extends UnifiedClassInstanceBaseOptional, WithPrice, WithSignupMax {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceBase
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceBase
   */
  signupMax?: number;
}

export interface UnifiedClassInstanceBaseTrackedI extends WithPriceOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceBase
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceBase
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassInstanceBase",
  function (model: UnifiedClassInstanceBase) {},
);

export type UnifiedClassInstanceBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
}>;

export var UnifiedClassInstanceBaseMeta: UnifiedClassInstanceBaseMetaI =
  {} as UnifiedClassInstanceBaseMetaI;
UnifiedClassInstanceBaseMeta = typeMeta("UnifiedClassInstanceBase", {
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = UnifiedClassInstanceBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([WithPriceMeta]);
  metaI.price.inheritedFrom = WithPriceMeta.price;
  metaI.interfaces = metaI.interfaces.concat([WithSignupMaxMeta]);
  metaI.signupMax.inheritedFrom = WithSignupMaxMeta.signupMax;
});

export class UnifiedClassInstanceBaseTracked
  extends WithPriceTracked
  implements UnifiedClassInstanceBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  constructor(
    config?: UnifiedClassInstanceBaseOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: UnifiedClassInstanceBaseOptional,
    options?: AssignOptions,
  ): UnifiedClassInstanceBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassInstanceBaseTrackedI {
    const cloned = {} as UnifiedClassInstanceBaseTrackedI;
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassInstanceBaseTrackedI {
    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    return this;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceBaseMeta.price,
      UnifiedClassInstanceBaseMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceBaseMeta.signupMax,
      UnifiedClassInstanceBaseMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
